export const baseUrlReplacer = (app, url) => {
  if (!app?.flags?.custom_domain || !app?.id) return url;
  try {
    const urlObj = new URL(url);
    const baseUrl = `${urlObj.protocol}//${urlObj.hostname}`;
    if (
      baseUrl !== `https://${app.id}.redfastlabs.com` &&
      baseUrl !== "https://assets.redfastlabs.com"
    ) {
      return url.replace(baseUrl, `https://${app.id}.redfastlabs.com`);
    }

    return url;
  } catch {
    return url;
  }
};
